/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { ChangeEvent, useEffect, useState } from "react";
import { workflow } from "../../../service/workflow";
import { GrEdit } from "react-icons/gr";
import CustomToast from "../../../widgets/toaster";
import { Link } from "react-router-dom";
import { TfiClose } from "react-icons/tfi";
import { Modal } from "react-bootstrap";
import AlertModal from "../../../widgets/alertModal";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { ObservationScheduleTable, ObservationScheduleToggle, useObservationSchedule } from "./partials/observationSchedule";
import { helperFunctions } from "../../../utils/helper";

interface InnerWorkFlowProps {
  setTab: (type: string) => void;
  activityId: any;
  selectedIds: string;
  flowName: string;
  editWorkFlow: {
    id: number;
    processDetails: any[];
    status: string;
    name: string;
    master_activity_id: any;
  };
  setEditWorkFlow: React.Dispatch<
    React.SetStateAction<{
      id: number;
      processDetails: any[];
      status: string;
      name: string;
      master_activity_id: any;
    }>
  >;
}

const WorkflowInnerPage: React.FC<InnerWorkFlowProps> = ({
  setTab,
  activityId,
  selectedIds,
  editWorkFlow,
  flowName,
  setEditWorkFlow,
}) => {

  const { t } = useTranslation();

  const [process, setProcess] = useState<Array<any>>([]);
  const [processId, setProcessId] = useState<any>("");
  // const [editWorkFlow, setEditWorkFlow] = useState<any>({});
  const [step, setStep] = useState(2);
  const [processField, setProcessField] = useState<Array<any>>([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [formValues, setFormValues] = useState<{ [key: string]: string | string[] }>({});
  const [rows, setRows] = useState([{ id: 1, content: "" }]);
  const [sequence, setSequence] = useState(1);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [plateTypes, setPlateTypes] = useState<{ id: string; plate_type: string; status: string }[]>([]);
  const [containerCapacityList, setContainerCapacityList] = useState<Array<any>>([]);
  const [equipmentList, setEquipmentList] = useState<Array<any>>([]);
  const [draftAlert, setDraftAlert] = useState(false);
  const [processFixedState, setprocessFixedState] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [processLength, setprocessLength] = useState(false);
  const [activityDurationDays, setActivityDurationDays] = useState("");
  const {
    scheduleEnabled,
    setScheduleEnabled,
    days,
    setDays,
    toggleDayEnabled,
    deleteDay,
    addDay,
    clearAll
  } = useObservationSchedule();

  // handle process change
  const handleProcessChange = (event: any) => {
    setProcessId(event.target.value);
    const selectedActivity = process.find(
      (act) => act.id == event.target.value
    );
    setProcessField(selectedActivity?.attributes);
    // Clear form data when activity changes
    // setFormData({});
    setFormValues({});
    clearAll();
  };

  // render all initial apis
  useEffect(() => {
    if (editWorkFlow?.master_activity_id !== 0) {
      ProcessList(editWorkFlow?.master_activity_id);
    }
    setUseEffectRequired(false);
    let processId = editWorkFlow?.master_activity_id
    if (processId === "12"){
      listAllMediaMasterPlateTypes();
      listContainerCapacity();
    } else {
      getPlateTypeList();
    }
    // listEquipments();
  }, [editWorkFlow, useEffectRequired]);

  useEffect(() => {
    getWorkFlowById(selectedIds);
  }, [useEffectRequired]);

  useEffect(() => {
    handleEditRow(editWorkFlow?.processDetails[0]?.id);
    setUseEffectRequired(false);
  }, [editWorkFlow?.processDetails, useEffectRequired]);

  useEffect(() => {
    const selectedOption = process.find((obj) => obj.fixedSequence == "1");
    if (selectedOption) {
      setProcessId(selectedOption.id);
      handleProcessChange({ target: { value: selectedOption.id } });
    }
    setUseEffectRequired(false);
  }, [process, useEffectRequired]);

  useEffect(() => {
    const selectedProcess = process.find((obj) => obj.id == processId);
    let hasFixedSequence = selectedProcess?.fixedSequence == "1";

    // if (process.some((obj: any) => obj.id === processId && hasFixedSequence && !processFixedState)) {
    //   setIsDisabled(true);
    // } else {
    //   setIsDisabled(false);
    // }
    // if (hasFixedSequence && processFixedState && processLength) {
    //   setIsDisabled(true);
    // }

    const shouldDisable =
      process.some(
        (obj: any) =>
          obj.id == processId && hasFixedSequence && !processFixedState
      ) ||
      (hasFixedSequence && processFixedState && processLength);

    setIsDisabled(shouldDisable);

    setUseEffectRequired(false);
  }, [
    processId,
    process,
    editWorkFlow,
    workflow,
    useEffectRequired,
    processFixedState,
  ]);

  useEffect(() => {
    if (processId !== undefined) {
      listEquipments();
    }
  }, [processId]);

  // handle back to home 
  const backToHome = () => {
    setProcessField([]);
    setProcess([]);
    setFormValues({});
    setProcessId("");
    setSequence(1);
    setEditWorkFlow({
      id: 0,
      processDetails: [],
      status: "",
      name: "",
      master_activity_id: 0,
    });
    setTab("1");
    clearAll();
  };

  // get process list
  const ProcessList = async (id: string) => {
    try {
      const response = await workflow.ProcessList(id);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any) => {
              return {
                id: element.id,
                name: element.name,
                attributes: element.attributes,
                fixedSequence: element.fixed_sequence,
                label_name: element.label_name,
              };
            });
            setProcess(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProcess([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get workflow details by id
  const getWorkFlowById = async (id: string) => {
    try {
      const response = await workflow.EditById(id);
      if (response.status && response.statusCode === 200) {
        try {
          const rowData = {
            id: response.data.id,
            processDetails: response.data.process_details,
            status: response.data.status,
            name: response.data.name,
            master_activity_id: response.data.master_activity_id,
          };

          setEditWorkFlow(rowData);

          if (
            Array.isArray(rowData.processDetails) &&
            rowData.processDetails.length == 0
          ) {
            setprocessFixedState(true);
            setprocessLength(true);
            console.log(rowData.processDetails.length, "add modal true");
          } else {
            setprocessFixedState(false);
            setprocessLength(false);
            console.log(rowData.processDetails.length, "add modal false");
          }

          handleEditRow(rowData?.processDetails[0]?.id);
          ProcessList(response.data.master_activity_id);
          if (response.data.master_activity_id === "12"){
            listAllMediaMasterPlateTypes();
            listContainerCapacity();
          } else {
            getPlateTypeList();
          }
          // getPlateTypeList();
          // listEquipments();
        } catch (error) {
          console.log(error);
        }
      } else {
        setEditWorkFlow({
          id: 0,
          processDetails: [],
          status: "",
          name: "",
          master_activity_id: 0,
        });
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // const handleInputChange = (event: any) => {
  //   const { name, value } = event.target;
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     [name]: value,
  //   }));
  // };

  // handle input value change
  const handleInputChange = (event: any) => {
    const { name, value, type, selectedOptions } = event.target;

    if (type === "select-multiple") {
      // If it's a multi-select, map the selected options to an array of values
      const selectedValues = Array.from(selectedOptions).map((option: any) => option.value);
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: selectedValues, // Store the array of selected values
      }));
    } else {
      // For other input types, just store the string value
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));

      if (name === "88") {
        setActivityDurationDays(value);
        setFormValues((prevValues) => ({
        ...prevValues,
        ["1"]: helperFunctions.convertDaysToHHMM(value),
      }));
      }
    }
  };

  //  handle next click
  const handleNextClick = async () => {
    const attributeValues = Object.keys(formValues).map((key) => ({
      master_process_atributes_mapping_id: key,
      value: formValues[key],
    }));

    const dataToSend = {
      id: selectedRowId ? selectedRowId : 0,
      sequence: sequence ? sequence : 1,
      activity_workflow_definition_id: selectedIds,
      master_process_id: processId,
      attribute_values: attributeValues,
      observation_schedule: days.map((d) => ({
        sequence: d.id,
        observation_day: Number(d.day),
      })),
      interface_name: "Workflow"
    };

    try {
      const response = await workflow.saveWorkFlowDetails(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastMessage(response.message);
        setToastType("success");
        setUseEffectRequired(true);
        closeModal();
        setErrors({});
        setProcessId("");
        setSelectedRowId(0);
        setFormValues({});
        clearAll();
      } else {
        setToastMessage(response.message);
        setToastType("error");
        setprocessFixedState(true);
      }
      setShowToast(true);
      setDraftAlert(false);
    } catch (error) {
      console.error("user response", error);
    }
  };

  // const getNextSequence = () => {
  //   const maxSequence = Math.max(
  //     ...editWorkFlow?.processDetails.map((row) => Number(row.sequence))
  //   );
  //   return maxSequence + 1;
  // };

  // get next sequence
  const getNextSequence = () => {
    const sequences = editWorkFlow?.processDetails
      .map((row) => Number(row.sequence))
      .filter((num) => !isNaN(num)); // Filter out any non-numeric values

    const maxSequence = sequences.length > 0 ? Math.max(...sequences) : 0;

    return maxSequence + 1;
  };

  // handle add process click
  const handleAddRow = () => {
    setShowAddModal(true);
    setprocessFixedState(true);
    setFormValues({});
    clearAll();
    setSelectedRowId(0);
    // setIsDisabled(false);
    const newSequence = getNextSequence();
    setSequence(newSequence);
  };

  // handle edit icon click
  const handleEditRow = (id: any) => {
    // setShowAddModal(true);
    setSelectedRowId(id);

    const itemToEdit: any = editWorkFlow?.processDetails?.find(
      (item: any) => item.id == id
    );

    const selectedActivity = process.find(
      (act) => act.id == itemToEdit?.master_process_id
    );
    setProcessField(selectedActivity?.attributes);
    setSequence(Number(itemToEdit?.sequence));
    setProcessId(itemToEdit?.master_process_id);

    const isFixedSequence = Number(itemToEdit?.sequence) == 1;

    // If the sequence is 1, set processFixedState to true, else false
    if (isFixedSequence) {
      setprocessFixedState(false);
    } else {
      setprocessFixedState(true);
    }

    if (itemToEdit !== 0) {
      const newFormValues: { [key: string]: string } = {};

      itemToEdit?.attribute_values.forEach((obj: any) => {
        newFormValues[obj.master_process_atributes_mapping_id] = obj.value;
        if (obj.master_process_atributes_mapping_id === "88") {
          setActivityDurationDays(obj.value);
        }
      });


      // NEW: rebuild days from observation_schedule
      const newDays = (itemToEdit?.observation_schedule ?? [])
        .map((obj: any) => ({
          id: Number(obj.sequence),
          day: String(obj.observation_day),
          enabled: true,
        }))
        .sort((a: any, b:any) => a.id - b.id); // keep order consistent (sequence 1, 2, 3...)

      setDays(newDays);

      setFormValues(newFormValues);
    } else {
      setFormValues({});
      clearAll();
    }
  };

  // handle close modal 
  const closeModal = () => {
    setShowAddModal(false);
    setprocessFixedState(true);
    setErrors({});
    setProcessId("");
    setSelectedRowId(0);
  };

  // get plate type list
  const getPlateTypeList = async () => {
    try {
      const response = await workflow.listAllPlateTypes();
      if (response.status && response.statusCode === 200) {
        setPlateTypes(response.data);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

   // get media master plate type list (sterility testing)
  const listAllMediaMasterPlateTypes = async () => {
    try {
      const response = await workflow.listAllMediaMasterPlateTypes();
      if (response.status && response.statusCode === 200) {
        setPlateTypes(response.data);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get conatiner capacity list (size)
  const listContainerCapacity = async () => {
    try {
      const response = await workflow.listContainerCapacity();
      if (response.status && response.statusCode === 200) {
        setContainerCapacityList(response.data);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // list equments
  const listEquipments = async () => {
    // alert(processId)
    try {
      // const mappedProcessId = mapProcessId(processId); // Map processId before passing it to the API
      const response = await workflow.listEquipmentFilter(processId);

      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setEquipmentList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setEquipmentList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // Helper function to map processId values
  const mapProcessId = (id: string) => {
    switch (id) {
      case "1":
        return "1";
      case "8":
        return "3";
      case "10":
        return "4";
      case "11":
        return "6,7";
      default:
        return id;
    }
  };

  const selectStyles = {
    container: (provided: any) => ({
      ...provided,
      width: '100%',
      minWidth: '180px',
    }),
    control: (provided: any) => ({
      ...provided,
      width: '100%',
      minWidth: '180px',
      minHeight: '30px',
      height: 'auto',
      overflow: 'visible',
    }),
    menu: (provided: any) => ({
      ...provided,
      width: '100%',
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      flexWrap: 'wrap',
      overflow: 'visible',
      maxHeight: 'none',
    }),
    multiValue: (provided: any) => ({
      ...provided,
      height: 'auto',
    }),
    multiValueLabel: (provided: any) => ({
      ...provided,
      fontSize: '14px',
    }),
    multiValueRemove: (provided: any) => ({
      ...provided,
      padding: '2px',
    }),
  };

  // const validateFields = () => {
  //   const newErrors: { [key: string]: string } = {};

  //   processField?.forEach((attr) => {
  //     const fieldName = attr.master_process_atributes_mapping_id;
  //     const value = formValues[fieldName];

  //     // Custom error messages for specific attributes
  //     switch (attr.name) {
  //       case "select_equipment":
  //         if (!value) newErrors[fieldName] = "Please select an equipment";
  //         break;
  //       case "plate_size_type":
  //         if (!value) newErrors[fieldName] = "Please select a plate size type";
  //         break;
  //       case "plate_grade":
  //         if (!value) newErrors[fieldName] = "Please enter the plate grade";
  //         break;
  //       case "colony_identification":
  //         if (!value)
  //           newErrors[fieldName] =
  //             "Please specify if colony identification is required";
  //         break;
  //       case "flora_identification":
  //         if (value === "")
  //           newErrors[fieldName] =
  //             "Please specify if flora identification is required";
  //         break;
  //       case "autoclave_stop_manual":
  //         if (value === "")
  //           newErrors[fieldName] = "Please specify if manual stop is needed";
  //         break;
  //       case "duration":
  //       case "over_due_intervel":
  //       case "buffer_time_for_start_process":
  //       case "buffer_time_for_stop_process":
  //       case "maximum_interval_for_next_process":
  //         if (!value) {
  //           newErrors[fieldName] = "This field is required";
  //         } else {
  //           // Validate the duration format hh:mm:ss
  //           const timePattern = /^\d{1,2}:[0-5]\d$/;
  //           if (!timePattern.test(value)) {
  //             newErrors[fieldName] = "Time must be in HH:MM format";
  //           }
  //         }
  //         break;

  //       // Positive integer validation
  //       case "over_due_intervel":
  //       case "buffer_time_for_start_process":
  //       case "buffer_time_for_stop_process":
  //       case "maximum_interval_for_next_process":
  //         if (!value) {
  //           newErrors[fieldName] = `${attr.label_name} is required`;
  //         } else if (!/^\d+$/.test(value)) {
  //           newErrors[
  //             fieldName
  //           ] = `${attr.label_name} must be a positive integer`;
  //         } else if (parseInt(value, 10) <= 0) {
  //           newErrors[
  //             fieldName
  //           ] = `${attr.label_name} must be greater than zero`;
  //         }
  //         break;

  //       // Min and Max temperature validation with comparison check
  //       case "min_temperature":
  //       case "max_temperature":
  //         // Check if the value is missing
  //         if (!value) {
  //           newErrors[fieldName] = `${attr.label_name} is required`;
  //         }
  //         // Check if the value is not a positive integer
  //         else if (!/^\d+$/.test(value)) {
  //           newErrors[
  //             fieldName
  //           ] = `${attr.label_name} must be a positive integer`;
  //         }
  //         // Check if the value is less than or equal to 0
  //         else if (parseInt(value, 10) <= 0) {
  //           newErrors[
  //             fieldName
  //           ] = `${attr.label_name} must be greater than zero`;
  //         }

  //         // You may include further validations or break out as required
  //         break;

  //       // Default required field validation
  //       default:
  //         if (!value?.trim()) {
  //           newErrors[fieldName] = `${attr.label_name} is required`;
  //         }
  //         break;
  //     }
  //   });

  //   setErrors({ ...newErrors }); // Update the errors state

  //   // Return true if no errors, otherwise false
  //   return Object.keys(newErrors).length === 0;
  // };

  const validateFields = () => {
    const newErrors: { [key: string]: string } = {};

    processField?.forEach((attr) => {
      const fieldName = attr.master_process_atributes_mapping_id;
      const value = formValues[fieldName];

      // Custom error messages for specific attributes
      switch (attr.name) {
        case "plate_size_type":
          // Check if value is an array and its length is 0 (empty array)
          if (Array.isArray(value) && value.length == 0) {
            newErrors[fieldName] = `Please select a ${attr.label_name}`;
          } if (!value) newErrors[fieldName] = `Please select a ${attr.label_name}`;
          break;

        case "select_equipment":
          if (!value) newErrors[fieldName] = "Please select an equipment";
          break;

        case "plate_grade":
        case "colony_identification":
        case "flora_identification":
        case "autoclave_stop_manual":
          // For string values, check if they are empty
          if (typeof value === "string" && value.trim() == "") {
            newErrors[fieldName] = `Please specify if ${attr.label_name} is required`;
          }
          break;

        case "duration":
        case "over_due_intervel":
        case "buffer_time_for_start_process":
        case "buffer_time_for_stop_process":
        case "maximum_interval_for_next_process":
          if (!value) {
            newErrors[fieldName] = "Duration must be in HH:MM format";
          } else {
            // Validate the duration format hh:mm
            // const timePattern = /^\d{1,2}:[0-5]\d$/;
            const timePattern = /^\d+:[0-5]\d$/;
            if (typeof value === "string" && !timePattern.test(value)) {
              newErrors[fieldName] = "Duration must be in HH:MM format";
            }
          }
          break;

        case "min_temperature":
        case "max_temperature":
          if (!value) {
            newErrors[fieldName] = `${attr.label_name} is required`;
          } else if (typeof value == "string" && !/^\d+$/.test(value)) {
            newErrors[fieldName] = `${attr.label_name} must be a positive integer`;
          } else if (typeof value == "string" && parseInt(value, 10) <= 0) {
            newErrors[fieldName] = `${attr.label_name} must be greater than zero`;
          }
          break;

        default:
          if (typeof value === "string" && !value.trim()) {
            newErrors[fieldName] = `${attr.label_name} is required`;
          }
          break;
      }
    });

    setErrors({ ...newErrors }); // Update the errors state

    // Return true if no errors, otherwise false
    return Object.keys(newErrors).length == 0;
  };

  // handle save draft button click
  const handleSaveDraft = (event: any) => {
    event.preventDefault();

    const isValid = validateFields();

    if (isValid) {
      setDraftAlert(true);
    }
  };

  return (
    <>
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      <nav aria-label="breadcrumb" className="breadcrumb-container row">
        <div className="col-10 d-flex">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item dashboard-hover"
              onClick={backToHome}
              style={{ cursor: "pointer" }}
            >
              {t('workflow.workflow')}
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {t('workflow.process')}
            </li>
          </ol>
        </div>
        <div className="col-2 d-flex"></div>
      </nav>

      {step == 2 && (
        <div className="workflow-container">
          <div className="left-tab">
            <h4>{flowName}</h4>
            {editWorkFlow?.processDetails?.map((row: any) => (
              <div key={row.id} className="row-item">
                <div className="process-name">{row.process_name}</div>
                <div className="edit-icon-container">
                  <GrEdit
                    className="edit-icon"
                    onClick={() => {
                      handleEditRow(row.id);
                      setShowAddModal(true);
                    }}
                  />
                </div>
              </div>
            ))}
            {!editWorkFlow?.processDetails?.some(
              (row: any) => row.process_keyword == "autoclave"
            ) && (
                <div className="add-row-button-container">
                  <button onClick={() => handleAddRow()} className="squareOrangeBtn3">
                    {t('workflow.addProcess')}
                  </button>
                </div>
              )}
          </div>
        </div>
      )}

      <Modal className="top-right-modal" centered={false} show={showAddModal}>
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">{t('workflow.process')}</p>
            <div onClick={closeModal} className="p-2 mx-3 my-2 wrapCloseIcon">
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>
        </div>
        <div className="selectWrap-email">
          <div className="form-group my-1">
            <label htmlFor="selectProcess" className="process-label">
              {t('workflow.selectProcess')} <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <select
              id="selectProcess"
              value={processId}
              disabled={isDisabled}
              className="placeholder-style"
              onChange={handleProcessChange}
              style={isDisabled ? { opacity: "0.5" } : { opacity: "1" }}
            >
              <option value="">{t('common.select')}</option>
              {process.map((obj, index) => (
                <option key={index} value={obj?.id}>
                  {obj?.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* <div
          className="selectWrap mt-5 mx-3"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <div
            className="process-content row"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start", // Ensures alignment to the left
            }}
          >
            {processField?.map((attr, index) => (
              <div
                className={`form-group col-6 my-1 ${
                  index % 2 === 0 ? "pr-2" : "pl-2"
                }`}
                key={attr.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <label
                  htmlFor={attr.label_name}
                  style={{
                    marginBottom: "4px",
                    fontWeight: "400",
                    color: "#333",
                    fontSize: "11px",
                    // whiteSpace: "normal",
                    // wordBreak: "break-word",
                  }}
                >
                  {attr.label_name} <span style={{ color: "red" }}>*</span>
                </label>

                {[
                  "select_equipment",
                  "lab_test_type",
                  "plate_size_type",
                  "plate_grade",
                  "colony_identification",
                  "flora_identification",
                  "autoclave_stop_manual",
                ].includes(attr.name) ? (
                  <>
                    <select
                      id={attr.name}
                      name={attr.master_process_atributes_mapping_id}
                      multiple={attr.name === "plate_size_type"}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: errors[attr.master_process_atributes_mapping_id]
                          ? "1px solid red"
                          : "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#888",
                        minWidth: "180px",
                      }}
                      value={
                        attr.name === "plate_size_type"
                          ? formValues[attr.master_process_atributes_mapping_id] || []
                          : formValues[attr.master_process_atributes_mapping_id] || ""
                      }
                      onChange={(e) => {
                        if (attr.name === "plate_size_type") {
                          // Handle multi-select
                          const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
                          setFormValues((prev) => ({
                            ...prev,
                            [attr.master_process_atributes_mapping_id]: selectedValues,
                          }));
                        } else {
                          handleInputChange(e);
                        }
                      }}
                    >
                      <option value="">Select {attr.label_name}</option>
                      {attr.name === "select_equipment" &&
                        equipmentList.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      {attr.name === "plate_size_type" &&
                        plateTypes.map((obj: any, index) => (
                          <option key={index} value={obj?.id}>
                            {obj?.plate_type}
                          </option>
                        ))}
                      {attr.name === "colony_identification" && (
                        <>
                          <option value="1">Required</option>
                          <option value="0">Not Required</option>
                        </>
                      )}
                      {attr.name === "flora_identification" && (
                        <>
                          <option value="1">Required</option>
                          <option value="0">Not Required</option>
                        </>
                      )}
                      {attr.name === "autoclave_stop_manual" && (
                        <>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </>
                      )}
                      {attr.name === "lab_test_type" && (
                        <>
                          <option value="1">Automatic</option>
                          <option value="0">Manual</option>
                        </>
                      )}
                    </select>
                    {errors[attr.master_process_atributes_mapping_id] && (
                      <p
                        className="errorText"
                        style={{ color: "red", fontSize: "12px" }}
                      >
                        {errors[attr.master_process_atributes_mapping_id]}
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      id={attr.name}
                      name={attr.master_process_atributes_mapping_id}
                      placeholder={
                        [
                          "duration",
                          "over_due_intervel",
                          "buffer_time_for_start_process",
                          "buffer_time_for_stop_process",
                          "maximum_interval_for_next_process",
                        ].includes(attr.name)
                          ? "hh:mm"
                          : "Please enter a value"
                      }
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: errors[attr.master_process_atributes_mapping_id]
                          ? "1px solid red"
                          : "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#888",
                        minWidth: "180px",
                        fontSize: "12px",
                      }}
                      value={
                        formValues[attr.master_process_atributes_mapping_id] ||
                        ""
                      }
                      onChange={handleInputChange}
                    />
                    {errors[attr.master_process_atributes_mapping_id] && (
                      <p
                        className="errorText"
                        style={{ color: "red", fontSize: "12px" }}
                      >
                        {errors[attr.master_process_atributes_mapping_id]}
                      </p>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>  */}

        <div className="selectWrap mt-5 mx-3" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <div className="process-content row" style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-start" }}>
            {processField?.map((attr, index) => (
              <div
                className={`form-group col-6 my-1 ${index % 2 == 0 ? "pr-2" : "pl-2"}`}
                key={attr.id}
                style={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}
              >
                <label
                  htmlFor={attr.label_name}
                  style={{ marginBottom: "4px", fontWeight: "400", color: "#333", fontSize: "11px" }}
                >
                  {attr.label_name} <span style={{ color: "red" }}>*</span>
                </label>

                {[
                  "select_equipment",
                  "lab_test_type",
                  "plate_size_type",
                  "plate_grade",
                  "colony_identification",
                  "flora_identification",
                  "autoclave_stop_manual",
                  "tube_size",
                  "observation_schedule"
                ].includes(attr.name) ? (
                  attr.name == "plate_size_type" ? (
                    <Select
                      isMulti
                      id={attr.name}
                      className="custom-select"
                      name={attr.master_process_atributes_mapping_id}
                      options={plateTypes.map((obj) => ({
                        value: obj.id,
                        label: obj.plate_type,
                      }))}
                      value={typeof formValues[attr.master_process_atributes_mapping_id] == "string"
                        ? (formValues[attr.master_process_atributes_mapping_id] as string)
                          .split(",")  // Split the comma-separated string into an array of selected values
                          .map((id) => {
                            const plate = plateTypes.find((obj) => obj.id == id);
                            return plate ? { value: plate.id, label: plate.plate_type } : null;
                          })
                          .filter(Boolean)
                        : []}
                      onChange={(selectedOptions) => {
                        setFormValues((prev) => ({
                          ...prev,
                          [attr.master_process_atributes_mapping_id]: selectedOptions
                            ? selectedOptions.map((option) => option!.value).join(",")  // Join selected values with a comma
                            : "",  // If no options selected, set an empty string
                        }));
                      }}
                        styles={selectStyles}
                    />
                  ) : attr.name == "tube_size" ? (
                <Select
                  isMulti
                  id={attr.name}
                  className="custom-select"
                  name={attr.master_process_atributes_mapping_id}
                  options={containerCapacityList.map((obj) => ({
                    value: obj.id,
                    label: obj.size,
                  }))}
                  value={typeof formValues[attr.master_process_atributes_mapping_id] == "string"
                    ? (formValues[attr.master_process_atributes_mapping_id] as string)
                      .split(",")
                      .map((id) => {
                        const capacity = containerCapacityList.find((obj) => obj.id == id);
                        return capacity ? { value: capacity.id, label: capacity.size } : null;
                      })
                      .filter(Boolean)
                    : []}
                  onChange={(selectedOptions) => {
                    setFormValues((prev) => ({
                      ...prev,
                      [attr.master_process_atributes_mapping_id]: selectedOptions
                        ? selectedOptions.map((option) => option!.value).join(",")
                        : "",
                    }));
                  }}
                  styles={selectStyles}
                />
                ) : attr.name == "observation_schedule" ? (
                  <div key={attr.id ?? index}>
                    <ObservationScheduleToggle
                      enabled={scheduleEnabled}
                      onChange={setScheduleEnabled}
                    />
                  </div>
                ) : (
                    <select
                      id={attr.name}
                      name={attr.master_process_atributes_mapping_id}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: errors[attr.master_process_atributes_mapping_id]
                          ? "1px solid red"
                          : "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#888",
                        minWidth: "180px",
                      }}
                      value={formValues[attr.master_process_atributes_mapping_id] || ""}
                      onChange={handleInputChange}
                    >
                      <option value="">{attr.label_name}</option>
                      {attr.name == "select_equipment" &&
                        equipmentList.map((type) => <option key={type.id} value={type.id}>{type.name}</option>)}
                      {attr.name == "colony_identification" && (
                        <>
                          <option value="1">{t('workflow.required')}</option>
                          <option value="0">{t('workflow.notRequired')}</option>
                        </>
                      )}
                      {attr.name == "flora_identification" && (
                        <>
                          <option value="1">{t('workflow.required')}</option>
                          <option value="0">{t('workflow.notRequired')}</option>
                        </>
                      )}
                      {attr.name == "autoclave_stop_manual" && (
                        <>
                          <option value="1">{t('workflow.yes')}</option>
                          <option value="0">{t('workflow.no')}</option>
                        </>
                      )}
                      {attr.name == "lab_test_type" && (
                        <>
                          <option value="1">{t('workflow.automatic')}</option>
                          <option value="0">{t('workflow.manual')}</option>
                        </>
                      )}
                    </select>
                  )
                ) : (
                  <input
                    type="text"
                    id={attr.name}
                    name={attr.master_process_atributes_mapping_id}
                    disabled={attr.name === "duration" && processId === "8"}
                    placeholder={[
                      "duration",
                      "over_due_intervel",
                      "buffer_time_for_start_process",
                      "buffer_time_for_stop_process",
                      "maximum_interval_for_next_process",
                    ].includes(attr.name)
                      ? "hh:mm"
                      : "Please enter a value"}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: errors[attr.master_process_atributes_mapping_id]
                        ? "1px solid red"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      color: "#888",
                      minWidth: "180px",
                      fontSize: "12px",
                      zIndex: attr.name == "buffer_time_for_start_process" ? 1000 : "auto"
                    }}
                    className="disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed disabled:opacity-70"
                    value={formValues[attr.master_process_atributes_mapping_id] || ""}
                    onChange={handleInputChange}
                  />
                )}

                {errors[attr.master_process_atributes_mapping_id] && (
                  <p className="errorText" style={{ color: "red", fontSize: "12px" }}>
                    {errors[attr.master_process_atributes_mapping_id]}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {processField?.some((attr) => attr.name === "observation_schedule") && (
          <div className="col-span-full w-full mt-4">
            <ObservationScheduleTable
              enabled={scheduleEnabled}
              days={days}
              toggleDayEnabled={toggleDayEnabled}
              deleteDay={deleteDay}
              addDay={addDay}
              maxDay={activityDurationDays}
            />
          </div>
        )}

        <div className="bottomArea">
          <button onClick={closeModal} className="modalCancelBtn">
            {t('buttons.cancel')}
          </button>
          <button
            className="squareOrangeBtn3"
            onClick={(e) => handleSaveDraft(e)}
          >
            {t('workflow.saveAsDraft')}
          </button>
        </div>
      </Modal>

      <AlertModal
        show={draftAlert}
        onHide={() => setDraftAlert(false)}
        title={t('common.alert')}
        message={t('workflow.saveAsDraft')}
        onConfirm={handleNextClick}
      />
    </>
  );
};

export default WorkflowInnerPage;
